import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { ChartType } from '@/components/Chart/types/highcharts';
import { ExportTypes } from '@/features/DataHub/modules/Export/types';

export type ExportState = {
  type: ChartType | ExportTypes.DATA | 'fullscreen';
  isLightMode: boolean;
  from: string | undefined;
  selectedTimeRange: string | undefined;
  exportNameBase?: string;
  seriesColors?: string[];
};

const initialState: ExportState = {
  type: ExportTypes.DATA,
  isLightMode: false,
  from: undefined,
  selectedTimeRange: undefined,
  exportNameBase: undefined,
  seriesColors: undefined
};

const exportSlice = createSlice({
  name: 'export',
  initialState,
  reducers: {
    setExport: (
      state,
      action: PayloadAction<{
        exportType?: ChartType | 'fullscreen';
        from?: string;
        isLightMode?: boolean;
        selectedTimeRange?: string;
        exportNameBase?: string;
        seriesColors?: string[];
      }>
    ) => {
      state.type = action.payload.exportType || ExportTypes.DATA;
      state.from = action.payload.from;
      state.isLightMode = action.payload.isLightMode || false;
      state.selectedTimeRange = action.payload.selectedTimeRange;
      state.exportNameBase = action.payload.exportNameBase;
      state.seriesColors = action.payload.seriesColors;
    }
  }
});

export const { setExport } = exportSlice.actions;
export default exportSlice.reducer;
